import { dateToDMY } from "@api";

export const getTimeFormatOptions = (timeZone: string): Intl.DateTimeFormatOptions => ({
  hour: "2-digit",
  minute: "2-digit",
  timeZone,
});

/** Formats a date as DD/MM/YYYY, optionally with " à HHhmm" */
export const formatDateWithOptionalTime = (
  date: Date,
  options: { prefix?: string; includeTime?: boolean } | undefined,
  timeZone: string
): string => {
  const dateStr = dateToDMY(date, timeZone);
  const timeStr = date.toLocaleTimeString("fr-FR", getTimeFormatOptions(timeZone)).replace(":", "h");
  if (options?.includeTime === false || timeStr === "00h00") {
    return dateStr;
  }
  return `${dateStr} ${options?.prefix ?? "à"} ${timeStr}`;
};
